import React from 'react';
import {createRoot, Root} from 'react-dom/client';
import WindowDimensionsProvider from '../components/WindowDimensionsProvider';
import Config from './Config';

const ThemeProvider = React.lazy(() => import(/* webpackChunkName: "misc1" */ '../components/mui/ThemeProvider'));
import styles from '../components/App.scss';
import {IContactFormProps} from '../components/forms/ContactForm';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {LocalizationProvider} from '@mui/x-date-pickers';
import AccountMenu from "../components/user/AccountMenu";
import LoginComponent from "../components/user/LoginComponent";

const ContactForm = React.lazy(() => import(/* webpackChunkName: "form" */ '../components/forms/ContactForm'));
const Cart = React.lazy(() => import(/* webpackChunkName: "commerce" */ '../components/commerce/Cart'));
const Checkout = React.lazy(() => import(/* webpackChunkName: "commerce" */ '../components/commerce/Checkout'));

const Product = React.lazy(() => import(/* webpackChunkName: "commerce" */ '../components/commerce/Product'));


class CreateComponent {

  reactDomRoot = new Map<HTMLElement, Root>();

  public init() {
    console.log('init');
  }


  public createDevApp(elm: HTMLElement) {
    console.warn('DevApp is commented out');
    // this.render(<DevApp />, elm);
  }


  public contactForm(
    elm: HTMLElement,
    pid: IContactFormProps['pid'],
    office: IContactFormProps['office'],
    agent: IContactFormProps['agent'],
    notifyUsingPlz: IContactFormProps['notifyUsingPlz'],
    type: IContactFormProps['type'],
    showAddress: IContactFormProps['showAddress'],
    addressIsMandatory: IContactFormProps['addressIsMandatory'],
    showImmoAddress: IContactFormProps['showImmoAddress'],
    immoAddressIsOptional: IContactFormProps['immoAddressIsOptional'],
    showMessage: IContactFormProps['showMessage'],
    showRecall: IContactFormProps['showRecall'],
    showFinviaPrivacy: IContactFormProps['showFinviaPrivacy'],
    price: IContactFormProps['price'],
    objectid: IContactFormProps['objectid'],
    mailIsMandatory: IContactFormProps['mailIsMandatory'],
    phoneIsMandatory: IContactFormProps['phoneIsMandatory']
  ) {
    if (type === 'contact') {
      const defaultValueOverrides = {};
      const labelOverrides = {};
      this.render(
        <ContactForm
          pid={pid}
          office={office}
          agent={agent}
          notifyUsingPlz={notifyUsingPlz}
          defaultValueOverrides={defaultValueOverrides}
          labelOverrides={labelOverrides}
          showMailAndPhone={true}
          showMail={false}
          showMessage={showMessage}
          addressIsMandatory={addressIsMandatory}
          showAddress={showAddress}
          showImmoAddress={showImmoAddress}
          immoAddressIsOptional={immoAddressIsOptional}
          showRecall={showRecall}
          showNewsletterCheckbox={true}
          sendMessageToOffice={true}
          showFinviaPrivacy={showFinviaPrivacy}
          type={type}
        />,
        elm
      );
    }
    if (type === 'valuation') {
      const defaultValueOverrides = {};
      const labelOverrides = {};
      this.render(
        <ContactForm
          pid={pid}
          office={office}
          agent={agent}
          notifyUsingPlz={true}
          defaultValueOverrides={defaultValueOverrides}
          labelOverrides={labelOverrides}
          showMailAndPhone={true}
          showMail={false}
          showMessage={true}
          addressIsMandatory={false}
          showAddress={false}
          showImmoAddress={true}
          immoAddressIsOptional={immoAddressIsOptional}
          showRecall={false}
          showNewsletterCheckbox={true}
          sendMessageToOffice={true}
          type={type}
        />,
        elm
      );
    }
    if (type === 'newsletter') {
      const defaultValueOverrides = {
        newsletter: true,
      };
      const labelOverrides = {
        de: {
          translation: {
            label_submit: 'Jetzt anmelden',
          },
        },
        en: {
          translation: {
            label_submit: 'Submit',
          },
        },
        es: {
          translation: {
            label_submit: 'Enviar',
          },
        },
      };
      this.render(
        <ContactForm
          pid={pid}
          office={office}
          agent={agent}
          notifyUsingPlz={notifyUsingPlz}
          defaultValueOverrides={defaultValueOverrides}
          labelOverrides={labelOverrides}
          showMailAndPhone={false}
          showMail={true}
          showMessage={false}
          showAddress={false}
          addressIsMandatory={false}
          showImmoAddress={false}
          immoAddressIsOptional={false}
          showRecall={false}
          showNewsletterCheckbox={false}
          sendMessageToOffice={false}
          type={type}
        />,
        elm
      );
    }
    if (type === 'expose') {
      const defaultValueOverrides = {};
      const privacyPolicyUrl = Config.getDrupalVar('dcReact.privacyPolicyUrl') as string;

      const labelOverrides = {
        de: {
          translation: {
            label_submit: 'Exposé anfordern',
            label_legalAgreement:
              'Ich akzeptiere die <a class="underline" target="_blank" href="' +
              privacyPolicyUrl +
              '">Datenschutzerklärung</a> und stimme einer Kontaktaufnahme für Rückfragen oder zu Informationszwecken zu.',
          },
        },
        en: {
          translation: {
            label_submit: 'Request the expose',
          },
        },
        es: {
          translation: {
            label_submit: 'Solicitar un folleto',
          },
        },
      };
      this.render(
        <ContactForm
          pid={pid}
          office={office}
          agent={agent}
          notifyUsingPlz={notifyUsingPlz}
          defaultValueOverrides={defaultValueOverrides}
          labelOverrides={labelOverrides}
          showMailAndPhone={true}
          mailIsMandatory={mailIsMandatory}
          phoneIsMandatory={phoneIsMandatory}
          showMail={false}
          showMessage={showMessage}
          showAddress={showAddress}
          addressIsMandatory={false}
          showImmoAddress={false}
          immoAddressIsOptional={false}
          showRecall={false}
          showNewsletterCheckbox={true}
          sendMessageToOffice={true}
          type={type}
          price={price}
          objectid={objectid}
        />,
        elm
      );
    }
    if (type === 'franchise') {
      const defaultValueOverrides = {};
      const labelOverrides = {
        de: {
          translation: {
            label_submit: 'Informationen anfordern',
          },
        },
        en: {
          translation: {
            label_submit: 'Request more information',
          },
        },
        es: {
          translation: {
            label_submit: 'Información requerida',
          },
        },
      };
      this.render(
        <ContactForm
          pid={pid}
          office={office}
          agent={agent}
          notifyUsingPlz={notifyUsingPlz}
          defaultValueOverrides={defaultValueOverrides}
          labelOverrides={labelOverrides}
          showMailAndPhone={true}
          showMail={false}
          showOfficeWish={true}
          showMessage={false}
          showAddress={false}
          addressIsMandatory={false}
          showImmoAddress={false}
          immoAddressIsOptional={false}
          showRecall={true}
          showNewsletterCheckbox={true}
          sendMessageToOffice={true}
          type={type}
        />,
        elm
      );
    }
    if (type === 'marketSurvey') {
      const defaultValueOverrides = {};
      const labelOverrides = {};
      this.render(
        <ContactForm
          pid={pid}
          office={office}
          agent={agent}
          notifyUsingPlz={false}
          defaultValueOverrides={defaultValueOverrides}
          labelOverrides={labelOverrides}
          showMailAndPhone={true}
          showMail={false}
          mailIsMandatory={true}
          showMessage={false}
          addressIsMandatory={false}
          showAddress={true}
          showImmoAddress={false}
          immoAddressIsOptional={false}
          showRecall={false}
          showNewsletterCheckbox={true}
          sendMessageToOffice={true}
          type={type}
        />,
        elm
      );
    }
  }

  public cart(elm: HTMLElement,) {
    this.render(<Cart/>, elm);
  }

  public checkout(elm: HTMLElement,) {
    this.render(<Checkout/>, elm);
  }

  public product(elm: HTMLElement,) {
    this.render(<Product/>, elm);
  }


  public accountMenu(elm: HTMLElement) {
    this.render(<AccountMenu/>, elm);
  }

  public loginComponent(elm: HTMLElement) {
    this.render(<LoginComponent
      type={'login'}
      onLogin={() => {}}
    />, elm);
  }

  protected render(Component, elm) {
    const locale = (Config.getDrupalVar('path.currentLanguage') as string) ?? 'de';

    if (!this.reactDomRoot.has(elm)) {
      this.reactDomRoot.set(elm, createRoot(elm));
    }

    this.reactDomRoot.get(elm).render(
      <React.Suspense fallback={<div>Loading...</div>}>
        <ThemeProvider>
          <WindowDimensionsProvider>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
              <div className={styles.app}>{Component}</div>
            </LocalizationProvider>
          </WindowDimensionsProvider>
        </ThemeProvider>
      </React.Suspense>
    );

    // hot module reload
    if (module && (module as any).hot) {
      console.log('react hot module reload register: ', elm?.id || [...elm?.classList].join(' '));
      (window as any).react_hmr?.register(Component, elm);
    }
  }

  public rerender(Component, elm) {
    console.log('react hot module reload: rerender', Component, elm);
    this.render(Component, elm);
  }

  private toBoolean = (str: string) => {
    return str && str !== 'false';
  };

  public renderAll() {
    const elements = document.querySelectorAll('[data-react-component]');

    const win = window as any;

    elements.forEach((elm: HTMLElement) => {
      const {reactComponent: component, ...props} = elm.dataset;

      if (!elm.getAttribute('data-react-is-rendered')) {
        elm.setAttribute('data-react-is-rendered', 'true');
        switch (component) {
          case 'contactForm': {
            // @ts-ignore
            const pid = (parseInt(props.pid) || null) as IContactFormProps['pid'];
            const office = (parseInt(props.office) || null) as IContactFormProps['office'];
            const agent = (parseInt(props.agent) || null) as IContactFormProps['agent'];
            const notifyUsingPlz = (props.notifyUsingPlz || 'false') as 'false' | 'true';
            const type = (props.type || 'contact') as IContactFormProps['type'];
            const showAddress = (props.showAddress || 'true') as 'false' | 'true';
            const addressIsMandatory = (props.addressIsMandatory || 'false') as 'false' | 'true';
            const immoAddressIsOptional = (props.immoAddressIsOptional || 'false') as 'false' | 'true';
            const showImmoAddress = (props.showImmoAddress || 'false') as 'false' | 'true';
            const showMessage = (props.showMessage || 'false') as 'false' | 'true';
            const showRecall = (props.showRecall || 'false') as 'false' | 'true';
            const showFinviaPrivacy = (props.showFinviaPrivacy || 'false') as 'false' | 'true';
            const price = (props.price || '') as IContactFormProps['price'];
            const objectid = (props.objectid || '') as IContactFormProps['objectid'];
            const mailIsMandatory = (props.mailIsMandatory || 'false') as 'false' | 'true';
            const phoneIsMandatory = (props.phoneIsMandatory || 'false') as 'false' | 'true';
            return this.contactForm(
              elm,
              pid,
              office,
              agent,
              notifyUsingPlz === 'true',
              type,
              showAddress === 'true',
              addressIsMandatory === 'true',
              showImmoAddress === 'true',
              immoAddressIsOptional === 'true',
              showMessage === 'true',
              showRecall === 'true',
              showFinviaPrivacy === 'true',
              price,
              objectid,
              mailIsMandatory === 'true',
              phoneIsMandatory === 'true'
            );
          }
          case 'cart': {
            return this.cart(elm);
          }
          case 'checkout': {
            return this.checkout(elm);
          }
          case 'product': {
            return this.product(elm);
          }
          case 'accountMenu': {
            return this.accountMenu(elm);
          }
          case 'loginComponent': {
            return this.loginComponent(elm);
          }
          default:
            console.warn(`Didn't found render function for component ${component}`);
        }
      }
    });
  }
}

const reactComponent = new CreateComponent();
(window as any).reactComponent = reactComponent;

export default reactComponent;
